import { configure, createRequestToken } from '@castleio/castle-js';

import { getCurrentCloudType } from '../utilities/env';
import { captureTaggedException, captureMessage } from '../utilities/analytics/error-reporting';
import { Capability } from '../utilities/analytics/capability-tags';
import { AppConfig } from '../types';

export function initCastle(appConfig: AppConfig | undefined) {
  if (getCurrentCloudType() !== 'commercial') {
    return; // Castle is not enabled for FedRAMP
  }

  if (!appConfig?.castlePublishableApiKey) {
    captureMessage(
      'castlePublishableApiKey is not present in appConfig during initCastle',
      {},
      'error',
      { castle: 'castle_config_error' }
    );

    return;
  }

  try {
    configure({ pk: appConfig.castlePublishableApiKey });
  } catch (e) {
    captureTaggedException(e, {
      capabilities: [],
      tags: { castle: 'castle_init_error' },
    });
  }
}

export async function getCastleRequestToken(
  capabilities: Capability[] = []
): Promise<string | undefined> {
  if (getCurrentCloudType() !== 'commercial') {
    return undefined;
  }

  try {
    return await createRequestToken();
  } catch (e) {
    console.error('castle error', e);
    captureTaggedException(e, {
      capabilities,
      tags: { castle: 'castle_request_token_error' },
    });
    return undefined;
  }
}
